import ColorBends from "../../components/backgrounds/ColorBends";
import AuthConfirmationPanel from "./AuthConfirmationPanel";
import AuthFooter from "./AuthFooter";
import GoogleAuthButton from "./GoogleAuthButton";
import PasswordStrengthChecklist from "./PasswordStrengthChecklist";
import ThemeToggle from "./ThemeToggle";
import { formatBrazilianPhoneNumber } from "./authPhoneFormat";
export default function AuthShell({
  title,
  firstName = "",
  lastName = "",
  phone = "",
  email = "",
  password = "",
  passwordConfirm = "",
  mode = "signin",
  theme = "dark",
  status,
  signupConfirmationEmail = "",
  passwordResetEmail = "",
  passwordResetComplete = false,
  loading = false,
  variant = "fullscreen",
  onFirstNameChange = () => {},
  onLastNameChange = () => {},
  onPhoneChange = () => {},
  onEmailChange = () => {},
  onPasswordChange = () => {},
  onPasswordConfirmChange = () => {},
  onModeChange = () => {},
  onThemeToggle = () => {},
  onSubmit = () => {},
  onGoogleSignIn = () => {},
}) {
  const logoSrc = `${process.env.PUBLIC_URL || ""}/suptracker.png`;
  const isLightTheme = theme === "light";
  const isEmbedded = variant === "embedded";
  const showPasswordStrength = mode === "signup" || mode === "recovery";

  return (
    <div className={`auth-shell auth-shell--${variant}`}>
      {!isEmbedded && <ThemeToggle theme={theme} onToggle={onThemeToggle} />}
      {!isEmbedded && (
        <ColorBends
  colors={isLightTheme ? ["#efe6d2", "#d4a44b", "#9f7a22"] : ["#9e4b07", "#9e4b07", "#775815"]}
  rotation={90}
  speed={0.21}
  scale={0.9}
  frequency={1}
  warpStrength={0.99}
  mouseInfluence={0.001}
  noise={0.02}
  parallax={0.5}
  iterations={1}
  intensity={1.5}
  bandWidth={17}
  transparent
  autoRotate={0}
  color="#F97316"
  className="auth-color-bends"
        />
      )}
      {!isEmbedded && (
        <div className={`auth-shell__scrim ${isLightTheme ? "auth-shell__scrim--light" : "auth-shell__scrim--dark"}`} />
      )}
      <div className={`auth-shell__content ${mode === "signup" ? "auth-shell__content--wide" : ""}`}>
        <img
          src={logoSrc}
          alt="orion33"
          className="auth-shell__logo"
        />
      {signupConfirmationEmail || passwordResetEmail || passwordResetComplete ? (
        <AuthConfirmationPanel
          signupConfirmationEmail={signupConfirmationEmail}
          passwordResetEmail={passwordResetEmail}
          passwordResetComplete={passwordResetComplete}
          onModeChange={onModeChange}
        />
      ) : (
      <form
        className={`panel auth-login-form auth-login-form--${mode}`}
        onSubmit={onSubmit}
        >
          <h1 className="auth-login-form__title">
          {title}
        </h1>

        {mode === "signup" && (
          <div className="auth-field-row">
            <div>
              <label className="field-label" htmlFor="auth-first-name">
                Nome
              </label>
              <input
                id="auth-first-name"
                className="input-field"
                type="text"
                value={firstName}
                placeholder="Nome"
                autoComplete="given-name"
                onChange={(event) => onFirstNameChange(event.target.value)}
                required
              />
            </div>

            <div>
              <label className="field-label" htmlFor="auth-last-name">
                Sobrenome
              </label>
              <input
                id="auth-last-name"
                className="input-field"
                type="text"
                value={lastName}
                placeholder="Sobrenome"
                autoComplete="family-name"
                onChange={(event) => onLastNameChange(event.target.value)}
                required
              />
            </div>
          </div>
        )}

        {mode !== "recovery" && (
        <div className={mode === "signup" ? "auth-field-row" : undefined}>
          <div>
            {mode === "signup" && (
              <label className="field-label" htmlFor="auth-email">
                Email
              </label>
            )}
            <input
              id="auth-email"
              className="input-field"
              type="email"
              value={email}
              aria-label="Email"
              placeholder={mode === "signup" ? "email@exemplo.com" : "Email"}
              autoComplete="email"
              onChange={(event) => onEmailChange(event.target.value)}
              required
            />
          </div>

          {mode === "signup" && (
            <div>
              <label className="field-label" htmlFor="auth-phone">
                Telefone
              </label>
              <input
                id="auth-phone"
                className="input-field"
                type="tel"
                inputMode="tel"
                value={phone}
                maxLength={15}
                pattern="\(\d{2}\) \d{4,5}-\d{4}"
                placeholder="(11) 99999-9999"
                title="Use o formato (11) 99999-9999"
                autoComplete="tel"
                onChange={(event) =>
                  onPhoneChange(formatBrazilianPhoneNumber(event.target.value))
                }
              />
            </div>
          )}
        </div>
        )}

        {mode !== "reset" && (
        <div className={mode === "signup" || mode === "recovery" ? "auth-field-row" : undefined}>
          <div>
            {mode !== "signin" && (
              <label className="field-label" htmlFor="auth-password">
                {mode === "recovery" ? "Nova senha" : "Senha"}
              </label>
            )}
            <input
              id="auth-password"
              className="input-field"
              type="password"
              value={password}
              aria-label={mode === "recovery" ? "Nova senha" : "Senha"}
              placeholder={mode === "recovery" ? "Nova senha" : "Senha"}
              autoComplete={mode === "signin" ? "current-password" : "new-password"}
              minLength={showPasswordStrength ? 8 : undefined}
              onChange={(event) => onPasswordChange(event.target.value)}
              required
            />
          </div>

          {(mode === "signup" || mode === "recovery") && (
            <div>
              <label className="field-label" htmlFor="auth-password-confirm">
                Confirmar senha
              </label>
              <input
                id="auth-password-confirm"
                className="input-field"
                type="password"
                value={passwordConfirm}
                placeholder="Confirmar senha"
                autoComplete="new-password"
                minLength={8}
                onChange={(event) => onPasswordConfirmChange(event.target.value)}
                required
              />
            </div>
          )}
        </div>
        )}

        {showPasswordStrength && <PasswordStrengthChecklist password={password} />}

        {status && (
          <div className={`backup-status backup-status--flush ${status.type}`}>
            {status.message}
          </div>
        )}

        <button className="btn-red auth-primary-button" type="submit" disabled={loading}>
          {loading
            ? "Aguarde..."
            : mode === "signin"
              ? "Entrar"
              : mode === "reset"
                ? "Enviar link"
                : mode === "recovery"
                  ? "Salvar senha"
                  : "Criar conta"}
        </button>

        {mode === "signin" && (
          <button
            className="auth-link-button auth-link-button--forgot"
            type="button"
            onClick={() => onModeChange("reset")}
          >
            Esqueceu sua senha?
          </button>
        )}

        {(mode === "signin" || mode === "signup") && (
          <>
            <div className="auth-divider">
              <span>ou</span>
            </div>
            <GoogleAuthButton
              mode={mode}
              loading={loading}
              onGoogleSignIn={onGoogleSignIn}
            />
          </>
        )}

        {mode !== "recovery" && (
          <button
            className="btn-ghost"
            type="button"
            onClick={() => onModeChange(mode === "signin" ? "signup" : "signin")}
          >
            {mode === "signin" ? "Criar uma conta" : "Já tenho uma conta"}
          </button>
        )}
      </form>
      )}
      </div>
      {!isEmbedded && <AuthFooter wide={mode === "signup"} />}
    </div>
  );
}
